<template>
    <div class="">
        <img v-if="hasImage"
             class="rounded w-100 h-100 objectFitCover"
             :src="store.attributes.images[0].card"
             :alt="store.attributes.name">
        <div v-else class="rounded bg-light-secondary text-muted h-100">
            <center vertical class="h-100 user-select-none">
                <span class="text-center" v-text="__('general.no_image')"/>
            </center>
        </div>
    </div>
</template>

<script>
import Center from '@components/Layout/Center.vue'

export default {
    components: {
        Center,
    },

    props: {
        store: Object,
    },

    computed: {
        hasImage() {
            if (!this.store.hasOwnProperty('attributes')) {
                return false
            }

            if (!this.store.attributes.hasOwnProperty('images')) {
                return false
            }

            return this.store.attributes.images.length > 0
        },
    },
}
</script>

<style scoped>
.objectFitCover {
    object-fit: cover;
}
</style>
